export default "__VITE_ASSET__CXxGBeEv__"